import { useOutletContext } from "react-router-dom";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import NotFoundPage from "components/error/NotFoundPage";

import { IntegrationView } from "../types";

const IntegrationsGroup = () => {
  const { integration } = useOutletContext<{ integration: IntegrationView }>();

  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: integration.name,
    },
  ]);

  if (!integration?.hasViewScreen) {
    return <NotFoundPage />;
  }

  const Page = integration.page;

  return <Page />;
};

export default IntegrationsGroup;
